import CupboardStation from '../../pictures/cupboard_station.png';

import CupboardLeathergoods from '../../pictures/cupboard_leathergoods.png';

import CupboardABP from '../../pictures/cupboard_ABP.png';
import CupboardSwiming from '../../pictures/cupboard_swiming.png';
import CupboardRibbon from '../../pictures/cupboard_ribbon.png';
import CupboardFiresafary from '../../pictures/cupboard_firesafary.png';
import CupboardClean from '../../pictures/cupboard_clean.png';
import './page-uslugi.css';

import Text from '../../@common.blocks/Text/index';
import ScrollToTop from '../../@common.blocks/ScrollToTop/index';

import Container from '../../@common.blocks/Container/index';

import Redcupboard1 from '../../pictures/redcupboard1.jpg';
import Redcupboard2 from '../../pictures/redcupboard2.jpg';
import Redcupboard3 from '../../pictures/redcupboard3.jpg';

import Wastewater1 from '../../pictures/cupboard_wastewater1.png';
import Wastewater2 from '../../pictures/cupboard_wastewater2.png';
import Wastewater3 from '../../pictures/cupboard_wastewater3.png';

import CupboardVentilation from '../../pictures/cupboard_ventilation.png';
import CupboardVentilationTwo from '../../pictures/cupboard_ventilation2.png';

import Carousel from '../../@common.blocks/Carousel/Carousel';

const PageUslugi = () => {
  return (
    <section className="page-uslugi">
      <ScrollToTop />

      <Container>
        <div className="page-uslugi__container">
          <div className="page-uslugi__smalcontainer">
            <div
              style={{
                maxWidth: 1200,
                marginLeft: 'auto',
                marginRight: 'auto',
                // marginTop: 40,
              }}
            >
              <Carousel
                imgs={[
                  {
                    src: Redcupboard1,
                    alt: 'Шкаф управления пожарной насосной станцией',
                    id: 'p1',
                  },
                  {
                    src: Redcupboard2,
                    alt: 'Шкаф управления пожарной насосной станцией',
                    id: 'p2',
                  },
                  {
                    src: Redcupboard3,
                    alt: 'Шкаф управления пожарной насосной станцией',
                    id: 'p3',
                  },
                ]}
              ></Carousel>
            </div>

            <Text component="div" section="uslugi" id="redcupboard">
              <ul id="redcupboard">
                <li>
                  <b>Наименование:</b> шкаф управления пожарной насосной
                  станцией.
                </li>
                <li>
                  <b>Комплектующие: </b>преобразователи частоты Danfoss,
                  контроллер управления Shinder Electric. Также применялись
                  комплектующие таких фирм как WAGO, Shinder Electric, ABB, IEK,
                  DKC.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 3 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <div
              style={{
                maxWidth: 1200,
                marginLeft: 'auto',
                marginRight: 'auto',
                // marginTop: 40,
              }}
            >
              <Carousel
                imgs={[
                  {
                    src: Wastewater1,
                    alt: 'Шкаф управления задвижками на очистных сооружениях',
                    id: 'p4',
                  },
                  {
                    src: Wastewater2,
                    alt: 'Шкаф управления задвижками на очистных сооружениях',
                    id: 'p5',
                  },
                  {
                    src: Wastewater3,
                    alt: 'Шкаф управления задвижками на очистных сооружениях',
                    id: 'p6',
                  },
                ]}
              ></Carousel>
            </div>

            <Text component="div" section="uslugi">
              {' '}
              <ul id="cupboard_wastewater">
                <li>
                  <b>Наименование:</b> шкаф управления задвижками на очистных
                  сооружениях.
                </li>
                <li>
                  <b>Комплектующие: </b>управление осуществляется станцией
                  распределенной переферии на базе модулей Siemens ET-200. При
                  сборке шкафа применялись комплектующие таких фирм как Siemens,
                  Shinder Electric, IEK, DKC, EKF, PHOENIX CONTACT.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 3 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <div>
              <img
                src={CupboardStation}
                alt=" Шкаф управления насосной станцией."
                className="page-uslugi__lonely-img"
              />
            </div>
            <Text component="div" section="uslugi" id="cupboard_station">
              <ul id="cupboard_station">
                <li>
                  <b>Наименование:</b> шкаф управления насосной станцией.
                </li>
                <li>
                  <b>Комплектующие: </b> преобразователи частоты ESQ, контроллер
                  управления ОВЕН. Также применялись комплектующие таких фирм
                  как Shinder Electric, ABB, IEK, DKC, ОВЕН.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <div>
              <img
                src={CupboardLeathergoods}
                alt=" Шкаф автоматики установкой разогрева элементов формовки кожаных перчаток."
                className="page-uslugi__lonely-img"
              />
            </div>
            <Text component="div" section="uslugi">
              <ul id="cupboard_leathergoods">
                <li>
                  <b>Наименование:</b> шкаф автоматики установкой разогрева
                  элементов формовки кожаных перчаток.
                </li>
                <li>
                  <b>Комплектующие: </b> контроллер управления ОВЕН. Также
                  применялись комплектующие таких фирм как EKF, IEK, DKC.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
                <li>
                  Дополнительно были проведены работы по установке и
                  программированию данного шкафа автоматики на производстве
                  заказчика.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <div
              style={{
                maxWidth: 1200,
                marginLeft: 'auto',
                marginRight: 'auto',
                // marginTop: 40,
              }}
            >
              <Carousel
                imgs={[
                  {
                    src: CupboardVentilation,
                    alt: 'Шкаф управления системы вентиляции',
                    id: 'p7',
                  },
                  {
                    src: CupboardVentilationTwo,
                    alt: 'Шкаф управления системы вентиляции',
                    id: 'p8',
                  },
                ]}
              ></Carousel>
            </div>

            <Text component="div" section="uslugi">
              <ul id="cupboard_ventilation">
                <li>
                  <b>Наименование:</b> шкаф управления системы вентиляции.
                </li>
                <li>
                  <b>Комплектующие: </b>применялись комплектующие таких фирм как
                  EKF, IEK, DKC, ABB.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <img
              src={CupboardABP}
              alt="Силовой шкаф учета с устройством АВР."
              className="page-uslugi__lonely-img"
            />
            <Text component="div" section="uslugi">
              <ul id="cupboard_ABP">
                <li>
                  <b>Наименование:</b>силовой шкаф учета с устройством АВР.
                </li>
                <li>
                  <b>Комплектующие: </b>в шкафу установлен комплектный блок АВР
                  производства CHINT. Также применялись комплектующие таких фирм
                  как CHINT, IEK, DKC.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <img
              src={CupboardSwiming}
              alt="Шкаф автоматики плавучей насосной станции с управлением по радиоканалу."
              className="page-uslugi__lonely-img"
            />
            <Text component="div" section="uslugi">
              <ul id="cupboard_swiming">
                <li>
                  <b>Наименование:</b>шкаф автоматики плавучей насосной станции
                  с управлением по радиоканалу.
                </li>
                <li>
                  <b>Комплектующие: </b>контроллер управления ОВЕН ПР200 с
                  модулем расширения дискретных входов/выходов. Плавный пуск
                  Instart работает сразу для двух насосов, преключение
                  происходит при помощи контакторов. Также предусмотрен байпас
                  плавного пуска. При сборке шкафа применялись комплектующие
                  таких фирм как CHINT, IEK, DKC, ОВЕН, EKF.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
                <li>
                  Также были произведены работы по монтажу данного шкафа и
                  доустановки терминального модема фирмы ОВЕН для управления и
                  мониторинга состояния насосной станцией по GSM каналу связи.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <img
              src={CupboardRibbon}
              alt=" Шкаф автоматики и управления конвейерными лентами."
              className="page-uslugi__lonely-img"
            />
            <Text component="div" section="uslugi">
              <ul id="cupboard_ribbon">
                <li>
                  <b>Наименование:</b> шкаф автоматики и управления конвейерными
                  лентами.
                </li>
                <li>
                  <b>Комплектующие: </b>контроллер управления Siemens S7-1200 с
                  модулем расширения дискретных входов/выходов. При сборке шкафа
                  применялись комплектующие таких фирм как Shinder Electric,
                  IEK, DKC, EKF.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <img
              src={CupboardFiresafary}
              alt=" Шкаф управления пожарной насосной станцией на релейной автоматике. "
              className="page-uslugi__lonely-img"
            />
            <Text component="div" section="uslugi">
              <ul id="cupboard_firesafary">
                <li>
                  <b>Наименование:</b> шкаф управления пожарной насосной
                  станцией на релейной автоматике.
                </li>
                <li>
                  <b>Комплектующие: </b>при сборке шкафа применялись
                  комплектующие таких фирм как Shinder Electric, IEK, DKC, ОВЕН,
                  EKF.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 1 недели.
                </li>
              </ul>
            </Text>
          </div>
          <div className="page-uslugi__smalcontainer">
            <img
              src={CupboardClean}
              alt=" Шкаф управления задвижками на очистных сооружениях.  "
              className="page-uslugi__lonely-img"
            />
            <Text component="div" section="uslugi">
              <ul id="cupboard_clean">
                <li>
                  <b>Наименование:</b> шкаф управления задвижками на очистных
                  сооружениях.
                </li>
                <li>
                  <b>Комплектующие: </b>управление осуществляется станцией
                  распределенной переферии на базе модулей Siemens ET-200. При
                  сборке шкафа применялись комплектующие таких фирм как Siemens,
                  Shinder Electric, IEK, DKC, EKF, PHOENIX CONTACT.
                </li>
                <li>
                  <b>Сроки изготовления:</b> 3 недели.
                </li>
              </ul>
            </Text>
          </div>
        </div>
      </Container>
    </section>
  );
};
export default PageUslugi;
